import yup, {
    cardNameValidator,
    integerNegativeAllowedValidator,
    stringValidator,
    booleanValidator,
    statusValidator,
    enumValidator,
    integerPositiveValidator,
} from '~/utils/validators.yup';

import { COMPARED_OPTIONS } from '~/config/constants';

export const combat = () =>
    yup.object({
        name: cardNameValidator(),
        strikeAdded: integerNegativeAllowedValidator,
        blockAdded: integerNegativeAllowedValidator,
        opponentDefenseDeducted: integerNegativeAllowedValidator,
        dvSet: integerNegativeAllowedValidator,
        dvAdded: integerNegativeAllowedValidator,
        dvDeducted: integerNegativeAllowedValidator,
        pointToPay: integerNegativeAllowedValidator,
        playerStatuses: statusValidator,
        opponentStatuses: statusValidator,
        healthToRegenerate: integerNegativeAllowedValidator,
        extraCritChance: integerNegativeAllowedValidator,
        canPreviewMapCard: booleanValidator,
        dvComparedOption: enumValidator(COMPARED_OPTIONS),
        dvComparedValue: integerPositiveValidator.required().min(0).max(12),
        pointComparedOption: integerNegativeAllowedValidator,
        pointComparedValue: integerNegativeAllowedValidator,
        hasFirstStrike: booleanValidator,
        strikeConditionAdded: integerNegativeAllowedValidator,
        blockConditionAdded: integerNegativeAllowedValidator,
        mainPhase: stringValidator.nullable(),
        isEffectStartedThisTurn: booleanValidator,
        isEffectStartedThisRound: booleanValidator,
        biomeIds: yup.array().nullable(),
        defendingSide: stringValidator.nullable(),
        hasActionCard: booleanValidator,
        isDuelBlind: booleanValidator,
    });
